import { safeApiRequest } from './apiClient';

/**
 * @param {{ aktif?: boolean }} [params]
 */
export const fetchBirimler = (params = {}) =>
  safeApiRequest('/api/birimler', {
    method: 'GET',
    query: params.aktif === true ? { aktif: 'true' } : undefined,
  });

export const createBirim = (body) =>
  safeApiRequest('/api/birimler', { method: 'POST', body });

export const updateBirim = (id, body) =>
  safeApiRequest(`/api/birimler/${encodeURIComponent(id)}`, { method: 'PUT', body });

/** @param {string[]} birimIds — yeni sıra (ilk öğe en üstte) */
export const reorderBirimler = (birimIds) =>
  safeApiRequest('/api/birimler/sira', { method: 'PUT', body: { birimIds } });

export const deleteBirim = (id) =>
  safeApiRequest(`/api/birimler/${encodeURIComponent(id)}`, { method: 'DELETE' });
